/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 13.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.modalTitle};
  cursor: pointer;
`;
Wrapper.displayName = 'Wrapper';
